import { AspectRatio, Image, Progress } from '@mantine/core'
import { Typography } from '../common/typography'
import Stat from '../stories/Stat/Stat'
import { StatsResult } from './api'
import classes from './PodiumLegendCard.module.css'
import clsx from 'clsx'
import { useMediaQuery } from '@mantine/hooks'
import { FmtColored, useFmtColor } from '../widgets/format'

export default function PodiumLegendCard({ result }: { result: StatsResult }) {
  const isDesktop = useMediaQuery('(min-width: 800px)')

  return (
    <div className={classes.container}>
      <div className={classes.teamContainer}>
        <AspectRatio ratio={1 / 1}>
          <Image
            src={result.team_logo.mini}
            alt={result.team_name}
            fit="scale-down"
            className={clsx(classes.teamLogo, {
              [classes.teamLogoMobile]: !isDesktop,
            })}
          />
        </AspectRatio>
        <Typography fs="sm" lh="140">
          {result.team_name}
        </Typography>
      </div>
      <div className={classes.statsContainer}>
        <Stat value={result.rank} isValueSub background="gray" />
        <Stat value={result.race_points} valueType="Pts" background="gray" />
      </div>
      <div className={classes.kpisContainer}>
        {result.kpis.map((kpi) => {
          return (
            <KpiRow
              key={kpi.metric_key}
              title={kpi.metric_name}
              value={kpi.percent}
              metric={kpi.metric_id}
            />
          )
        })}
      </div>
    </div>
  )
}

function KpiRow({
  title,
  value,
  metric,
}: {
  title: string
  value: number | null | undefined
  metric: string | number
}) {
  const color = useFmtColor({
    metric,
    value,
    component: 'percent',
    statistic: 'value',
  })

  return (
    <div className={classes.kpiItem}>
      <div className={classes.kpiRow}>
        <Typography fs="xs" fc={{ light: 'black', dark: 'gray-3' }} lh="150">
          {title}
        </Typography>
        <Typography fs="xs" ff="JetBrains Mono" lh="140">
          <FmtColored
            value={value}
            metric={metric}
            component="percent"
            statistic="value"
            override={{ percent_decimal_places: 1 }}
          />
        </Typography>
      </div>
      <Progress color={color} value={(value || 0) * 100} />
    </div>
  )
}
